module.exports = __webpack_public_path__ + "static/media/blog-42-1.3b33b9bb.webp";